import React from 'react';
import './CTASection.css';
import { useNavigate } from 'react-router-dom';
import { logEvent } from '../utils/analytics';

function CTASection() {
  const navigate = useNavigate();

  const handleCTAClick = () => {
    logEvent('Landing Page', 'cta_button_clicked', {
      button_text: 'Start Learning Free',
      section: 'bottom_cta',
    });
    navigate('/login');
  };

  return (
    <section className="cta-section" id="cta">
      <div className="cta-bg-gradient"></div>
      <div className="cta-bg-particles"></div>

      <div className="cta-container">
        <div className="cta-card">
          <div className="card-aurora"></div>
          <div className="cta-content">
            <div className="cta-badge">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M8 15C12.8747 15 15 12.949 15 8C15 12.949 17.1104 15 22 15C17.1104 15 15 17.1104 15 22C15 17.1104 12.8747 15 8 15Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M2 6.5C5.13376 6.5 6.5 5.18153 6.5 2C6.5 5.18153 7.85669 6.5 11 6.5C7.85669 6.5 6.5 7.85669 6.5 11C6.5 7.85669 5.13376 6.5 2 6.5Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
              Start Your Journey
            </div>

            <h2 className="cta-headline">
              Learn Smarter. Faster.<br/>
              <span className="headline-gradient">Together with AI.</span>
            </h2>

            <p className="cta-description">
              Join thousands of medical professionals mastering their craft with AI-powered learning. No technical skills needed — just curiosity and ambition.
            </p>

            <div className="cta-features-grid">
              <div className="mini-feature">
                <div className="feature-check">✓</div>
                <span>Instant AI Answers</span>
              </div>
              <div className="mini-feature">
                <div className="feature-check">✓</div>
                <span>Evidence-Based</span>
              </div>
              <div className="mini-feature">
                <div className="feature-check">✓</div>
                <span>24/7 Available</span>
              </div>
              <div className="mini-feature">
                <div className="feature-check">✓</div>
                <span>Free to Start</span>
              </div>
            </div>

            <div className="cta-button-wrapper">
              <button className="cta-main-button" onClick={handleCTAClick}>
                <span>Start Learning Free</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M7 17L17 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7 7H17V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <p className="cta-footer-text">No credit card required • Start in seconds</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTASection;
